module.exports = __webpack_public_path__ + "media/images/flags/64/Mars-205a0ac155c659b929d010638cf96937.png";